/**
 * @file Renders the login/bootstrap shell for auth-related states.
 */

const loadingIndicator = document.getElementById("loading-indicator");
const appContainer = document.getElementById("app");
const loginView = document.getElementById("login-view");
const loginBrandLogo = document.getElementById("login-brand-logo");
const loginErrorEl = document.getElementById("login-error-message");
const signInButton = document.getElementById("microsoft-signin-btn");

const SHELL_MESSAGES = {
    signed_out: "",
    sign_in_failed: "Sign-in failed. Please try again.",
    config_blocked: "Authentication is unavailable because the app environment configuration could not be loaded.",
    profile_bootstrap_failed: "Your session could not be prepared. Please try signing in again.",
    inactive_blocked: "This account is inactive. Please contact an administrator.",
    maintenance_blocked: "Non-admin sign-in is temporarily locked for maintenance.",
};

function syncLoginBranding() {
    const logo = window.__DFC_ENV_CONFIG__?.branding?.logo || null;
    if (!loginBrandLogo) {return;}

    if (logo?.url) {
        loginBrandLogo.src = logo.url;
        loginBrandLogo.classList.remove("hidden");
        return;
    }

    loginBrandLogo.removeAttribute("src");
    loginBrandLogo.classList.add("hidden");
}

/**
 * Renders the auth shell state.
 * @param {string} shellState The auth shell variant.
 * @param {object} [options] Rendering options.
 * @param {string} [options.message] Optional message override.
 */
export function renderAuthShell(shellState, options = {}) {
    syncLoginBranding();

    const message = options.message || SHELL_MESSAGES[shellState] || "";
    const isLoading = shellState === "auth_bootstrap_loading";
    const isAppReady = shellState === "app_ready";
    const isConfigBlocked = shellState === "config_blocked";
    const isBlocked = shellState === "inactive_blocked" ||
        shellState === "maintenance_blocked" ||
        isConfigBlocked;

    if (loadingIndicator) {
        loadingIndicator.classList.toggle("hidden", !isLoading);
    }
    if (appContainer) {
        appContainer.classList.toggle("hidden", !isAppReady);
    }
    if (loginView) {
        loginView.classList.toggle("hidden", isLoading || isAppReady);
    }

    if (loginErrorEl) {
        if (message) {
            loginErrorEl.textContent = message;
            loginErrorEl.classList.remove("hidden");
        } else {
            loginErrorEl.textContent = "";
            loginErrorEl.classList.add("hidden");
        }
    }

    if (signInButton) {
        signInButton.disabled = isLoading || isBlocked;
        signInButton.classList.toggle("opacity-50", signInButton.disabled);
        signInButton.classList.toggle("cursor-not-allowed", signInButton.disabled);
    }
}
